import Service, { service } from '@ember/service';

export const EVENT_NAMES = {
  openClientProfile: 'openClientProfile',
};

export default class MessagingEventsService extends Service {
  @service alertManager;
  @service intl;

  emit(eventName, data) {
    const messagingClient = document.querySelector('#ember-messaging-client');
    if (!messagingClient) {
      return this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.general_error'),
        type: 'error',
      });
    }
    const event = new CustomEvent('messagingEvent', { detail: { name: eventName, data } });
    messagingClient.dispatchEvent(event);
  }
}
